export const getDayOfTheWeek = (
  date: Date | string,
  format: "complet" | "short" = "complet",
): string => {
  const fechaObj = typeof date === "string" ? new Date(date) : date;

  if (isNaN(fechaObj.getTime())) {
    throw new Error("Fecha inválida");
  }

  const fullDays = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];
  const shortDays = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];

  return format === "complet"
    ? fullDays[fechaObj.getDay()]
    : shortDays[fechaObj.getDay()]; // Lunes or Lun
};

export const formatDateToTime = (date: Date | string): string => {
  const fechaObj = typeof date === "string" ? new Date(date) : date;
  if (isNaN(fechaObj?.getTime())) return "Fecha inválida";

  return fechaObj
    .toLocaleTimeString("es-ES", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .replace(/\./g, "");
}; // Salida "2:30 p.m."

export const formatDateCheckInOut = (fechaStr: string): string => {
  // 1. Dividimos la cadena para ignorar la hora y obtener día, mes y año
  const [fechaPart] = fechaStr.split(" ");
  const [dia, mes, anio] = fechaPart.split("/");

  // 2. Creamos el objeto Date (el mes en JS es base 0, por eso restamos 1)
  const fecha = new Date(Number(anio), Number(mes) - 1, Number(dia));

  // 3. Formateamos usando 'es-ES' para español
  return fecha.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).replace(".", ""); // Quitamos el punto que JS suele poner tras la abreviatura
}